//messages.js
export default {
	plan_id: "Plan Id",
	plan_code: "Plan Code",
	plan_name: "Plan Name",
	description: "Description",
	amount: "Amount",
	currency_code: "Currency Code",
	term_months: "Term Months",
	is_active: "Is Active",
	zoho_item_id: "Zoho Item Id",
	edit_subscription_plan: 'Edit Subscription Plan',
	add_subscription_plan: 'Add Subscription Plan',
	delete_subscription_plan: 'Delete Subscription Plan',
	subscription_plans: 'Subscription Plans',
	delete_subscription_plan_confirm: 'This action is not reversible!',
}